define('score_bootstrap/Components/ContentSearch/SearchQueryMessage',[
    "knockout",
    "score_bootstrap/Utils/UrlHelper"
], function (ko, urlHelper) {
    "use strict";

    function SearchQueryMessage(scope) {
        var query = urlHelper.getUrlParameters(window.location, "q");
        query = query.length ? query[0] : "";
        this.query = ko.observable(query);
        this.shouldShowMessage = ko.pureComputed(function () {
            return this.query().length > 0;
        }, this);
        ko.applyBindings(this, scope);
    }

    SearchQueryMessage.init =  function init(args) {
        return new SearchQueryMessage(args.scope);
    };

    return SearchQueryMessage;
});
